<script setup lang="ts">
import OHome from '~/components/organisms/Home.vue'
import { useAuth } from '~/store/auth'

definePageMeta({
  middleware: [
    () => {
      const userStore = useAuth()
      if (userStore.user !== null) {
        return navigateTo('/files')
      }
    },
  ],
})

useSeoMeta({
  title: 'Инфографика для маркетплейсов онлайн. Бесплатная программа Magvi',
  description: 'Бесплатная программа, в которой можно удалить фон, добавить ' +
    'подходящие иконки, выбрать готовую инфографику из шаблонов и отредактировать ее.',
})

useHead({
  link: [
    {
      rel: 'canonical',
      href: useRuntimeConfig().public.appUrl,
    },
  ],
})

</script>

<template>
  <OHome />
</template>
